import { render, staticRenderFns } from "./Guest.vue?vue&type=template&id=4b04919c&"
import script from "./Guest.vue?vue&type=script&lang=js&"
export * from "./Guest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports